import {
    LOAD_LIST,
    LOAD_PAGINATION,
    LOAD_NEW_LIST,
} from './constant';

export const initStateFeed = {
    loadList: [],
    pagination: {},
    newLoadList: {},
};

export default (state = initStateFeed, action) => {
    switch (action.type) {
        case LOAD_LIST: {
            return {
                ...state,
                loadList: action.payload,
            };
        }
        case LOAD_PAGINATION: {
            return {
                ...state,
                pagination: action.payload,
            };
        }
        case LOAD_NEW_LIST: {
            return {
                ...state,
                newLoadList: action.payload,
            };
        }
        default:
            return state;
    }
};
